import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BookingOrderService } from '../services/booking-order.service';

@Injectable()
export class BookingEventPacksGuard implements CanActivate {

  constructor(
    private bookingOrderService: BookingOrderService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.bookingOrderService.mainPageAreaItemPacks && this.bookingOrderService.mainPageAreaItemPacks.length > 0) {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
}
